/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Irrigation_Error_Settings_FailedInputs */

const vi_smartlab_irrigation_error_settings_failed = /** @type {(inputs: Smartlab_Irrigation_Error_Settings_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đọc hoặc lưu được cấu hình phun nước SmartLab, vui lòng thử lại sau`)
};

/**

* @param {Smartlab_Irrigation_Error_Settings_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_irrigation_error_settings_failed = /** @type {((inputs?: Smartlab_Irrigation_Error_Settings_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Irrigation_Error_Settings_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_irrigation_error_settings_failed(inputs)
});